/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import AdminLayout from './layouts/Admin';
import Login from './views/pages/Login';
import Logout from './views/pages/Logout';
import { getTokenData } from './utils/helpers';
import client from './utils/client';
import { Store } from './Store';
import VersionCheck from './components/VersionCheck';

const App = () => {
  const { state, dispatch } = useContext(Store);
  const location = useLocation();

  useEffect(() => {
    const tokenData = getTokenData();
    if (tokenData) {
      Sentry.setUser({ id: tokenData.gId, golfclub: tokenData.name });
    }
  }, []);

  useEffect(() => {
    (async () => {
      if (location.pathname === '/golfclub-admin/logout') return;
      const tokenData = getTokenData();
      if (!tokenData) return;

      // Fetch new notifications every 10 minute
      if (!state.notifications.fetched || Date.now() - state.notifications.fetched > 60000 * 10) {
        const { data } = await client(`admin-gc/notifications`);
        if (data) {
          dispatch({ type: 'NOTIFICATIONS_FETCHED', payload: data });
        }
      }

      // Fetch unhandled web sales every 30 minute
      if (
        !state.unhandledWebSales.fetched ||
        Date.now() - state.unhandledWebSales.fetched > 60000 * 30
      ) {
        const { data } = await client(`admin-gc/web-sales/sales`);
        if (data) {
          const unHandledWebSales = data.filter((s) => !s.complete).length;
          dispatch({ type: 'UNHANDLED_WEB_SALES', payload: unHandledWebSales });
        }
      }
    })();
  }, [location]);

  return (
    <>
      <VersionCheck path={location.pathname} language="sv" />
      <Routes>
        <Route path="/golfclub-admin/login" element={<Login />} />
        <Route path="/golfclub-admin/logout" element={<Logout />} />
        <Route path="/golfclub-admin/*" element={<AdminLayout />} />
      </Routes>
    </>
  );
};

export default App;
